import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Graphic from "@arcgis/core/Graphic";
import Point from "@arcgis/core/geometry/Point";
import Polyline from "@arcgis/core/geometry/Polyline";
import Polygon from "@arcgis/core/geometry/Polygon";
import * as geometryEngineAsync from "@arcgis/core/geometry/geometryEngineAsync";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";
import * as geometryService from "@arcgis/core/rest/geometryService";
export function getLayer(mapView, id) {
    let layer = mapView.map.layers.find(function (l) {
        return l.id === id;
    });
    return layer;
}
export function addGraphicLayer(name, mapView) {
    let graphicLayer = getLayer(mapView, name + "graphicLayer");
    if (graphicLayer === undefined) {
        graphicLayer = new GraphicsLayer({
            id: name + "graphicLayer"
        });
        mapView.map.add(graphicLayer);
    }
    return graphicLayer;
}
export function addGraphicToMap(graghicToMap) {
    if (graghicToMap.mapView && graghicToMap.clear) {
        graghicToMap.mapView.graphics.removeAll();
    }
    // if (graghicToMap.mapView && graghicToMap.mapView.graphics.length > 0) {
    //   graghicToMap.mapView.graphics.removeAll();
    // }
    let _geomerty = graghicToMap.feature.geometry || graghicToMap.feature;
    var graphic = new Graphic({
        geometry: _geomerty,
        attributes: graghicToMap.feature.attributes || graghicToMap.feature
    });
    switch (_geomerty.type) {
        case "polygon":
            graphic.symbol = graghicToMap.polygonSymbol();
            break;
        case "polyline":
            graphic.symbol = graghicToMap.polylineSymbol();
            break;
        case "point":
            graphic.symbol = graghicToMap.pointSymbol();
            break;
    }
    graghicToMap.mapView.graphics.add(graphic);
}
export function createGeometryPoint(point) {
    let geometry = new Point({
        x: point.x,
        y: point.y,
        spatialReference: point.spatialReference
    });
    return geometry;
}
export function createGeometryPolyline(polyline) {
    let geometry = new Polyline({
        hasM: polyline.hasM,
        hasZ: polyline.hasZ,
        paths: polyline.paths,
        spatialReference: polyline.spatialReference
    });
    return geometry;
}
export function createGeometryPolygon(polygon) {
    let geometry = new Polygon({
        hasM: polygon.hasM,
        hasZ: polygon.hasZ,
        rings: polygon.rings,
        spatialReference: polygon.spatialReference
    });
    return geometry;
}
export function addGraphic(addGraghicToLayer) {
    if (addGraghicToLayer.clear) {
        addGraghicToLayer.layer.removeAll();
    }
    let geomerty = addGraghicToLayer.feature.geometry || addGraghicToLayer.feature;
    var graphic = new Graphic({
        geometry: geomerty,
        attributes: addGraghicToLayer.feature.attributes || addGraghicToLayer.feature
    });
    switch (geomerty.type) {
        case "polygon":
            graphic.symbol = addGraghicToLayer.polygonSymbol();
            break;
        case "point":
            graphic.symbol = addGraghicToLayer.imageSymbol();
            break;
    }
    addGraghicToLayer.layer.add(graphic);
}
export function unionListGeometries(geometries) {
    let geometriesList = geometryEngineAsync.union(geometries);
    return geometriesList;
}
export async function isTouches(geometry1, geometry2) {
    let value = await geometryEngineAsync.touches(geometry1, geometry2);
    return value;
}
export function webMercatorToGeographicGeometry(geometry) {
    let check = webMercatorUtils.canProject(geometry, geometry);
    if (check) {
        return webMercatorUtils.webMercatorToGeographic(geometry);
    }
    return -1;
}
export function GeographicTowebMercatorGeometry(geometry) {
    return webMercatorUtils.geographicToWebMercator(geometry);
}
export function calculateAreaUsingGeodesicArea(geometry, arealUnits) {
    let area = geometryEngineAsync.geodesicArea(geometry, arealUnits);
    return area;
}
export function distanceGeometrys(geometry1, geometry2, distanceUnit) {
    return geometryEngineAsync.distance(geometry1, geometry2, distanceUnit);
}
export function bufferGeometry(geometry, distance, unit, unionResults) {
    return geometryEngineAsync.buffer(geometry, distance, unit, unionResults);
}
// export function projectOperation(url: string, param: __esri.ProjectParameters){
//   return geometryService.project(url, param);
// }
export function geometryServiceProjection(url, projectParameters) {
    return geometryService.project(url, projectParameters);
}
